(() => {
    function initTabSlider(sectionUid) {
        const root = document.getElementById(sectionUid);
        if (!root) return;
        const tabs = Array.from(root.querySelectorAll("[data-tab-btn]"));
        const panes = Array.from(root.querySelectorAll("[data-tab-pane]"));

        function bindArrows(pane) {
            const swiperEl = pane.querySelector("swiper-container");
            const prev = pane.querySelector(".custom-prev-button");
            const next = pane.querySelector(".custom-next-button");
            if (!swiperEl) return;
            const bind = () => {
                if (!swiperEl.swiper) return;
                if (prev && !prev._bound) {
                    prev.addEventListener("click", () =>
                        swiperEl.swiper.slidePrev()
                    );
                    prev._bound = true;
                }
                if (next && !next._bound) {
                    next.addEventListener("click", () =>
                        swiperEl.swiper.slideNext()
                    );
                    next._bound = true;
                }
            };
            if (!swiperEl.swiper) {
                try {
                    swiperEl.initialize && swiperEl.initialize();
                } catch (e) {}
                setTimeout(bind, 0);
            } else {
                bind();
            }
        }

        function activate(handle) {
            tabs.forEach((btn) =>
                btn.classList.toggle(
                    "is-active",
                    btn.dataset.tabBtn === handle
                )
            );
            panes.forEach((p) => {
                const on = p.dataset.tabPane === handle;
                p.style.display = on ? "" : "none";
                if (on) {
                    bindArrows(p);
                    const swiperEl = p.querySelector("swiper-container");
                    if (swiperEl && !swiperEl.swiper) {
                        try {
                            swiperEl.initialize && swiperEl.initialize();
                        } catch (e) {}
                    }
                    const ensureUpdate = () => {
                        if (swiperEl && swiperEl.swiper) {
                            try {
                                swiperEl.swiper.update();
                                if (
                                    swiperEl.swiper.scrollbar &&
                                    swiperEl.swiper.scrollbar.updateSize
                                ) {
                                    swiperEl.swiper.scrollbar.updateSize();
                                }
                            } catch (e) {}
                        }
                    };
                    ensureUpdate();
                    setTimeout(ensureUpdate, 0);
                    setTimeout(ensureUpdate, 50);
                    p.querySelectorAll("img").forEach((img) => {
                        if (!img.complete)
                            img.addEventListener("load", ensureUpdate, {
                                once: true
                            });
                    });
                }
            });
        }

        if (tabs.length) {
            activate(tabs[0].dataset.tabBtn);
            tabs.forEach((btn) =>
                btn.addEventListener("click", () =>
                    activate(btn.dataset.tabBtn)
                )
            );
        }
    }

    // Process any queued section UIDs (pushed before this script ran)
    const queue = Array.isArray(window.__atlasTabSliderQueue) ? window.__atlasTabSliderQueue : [];
    queue.forEach((uid) => initTabSlider(uid));

    // Expose for any UIDs pushed after this script ran
    window.__atlasTabSliderQueue = {
        push: (uid) => initTabSlider(uid)
    };
})();
